import { render } from "./Home.vue?vue&type=template&id=48d7d235&scoped=true&lang=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=48d7d235&lang=css&scoped=true"

import exportComponent from "C:\\laragon\\www\\icl-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d7d235"]])

export default __exports__